// extracted by mini-css-extract-plugin
export default {"row":"_0esro","seatInfoColumn":"_1wxvg","seatInfo":"BEzQC"};